import toast from "react-hot-toast";

const { clientAPI } = require("../client");

const getErrorMessages = (error) =>
  error?.response?.data?.errors?.map((err) => err.message) || [
    error?.response?.data?.message ||
      error?.response?.statusText ||
      error?.message ||
      "An unexpected error occurred.",
  ];

export const transactionCall = {
  getDetail: async ({ id, type }) => {
    try {
      const response = await clientAPI(
        "get",
        `/document/transaction/detail/${id}?type=${type}`,
      );

      return response;
    } catch (error) {
      console.error("Get transaction detail error:", error);

      getErrorMessages(error).forEach((message) => {
        toast.error(`${message}`);
      });

      throw error;
    }
  },

  updateDetail: async ({ id, type, data }) => {
    try {
      const response = await clientAPI(
        "put",
        `/document/transaction/detail/${id}?type=${type}`,
        data,
      );

      return response;
    } catch (error) {
      console.error("Update transaction detail error:", error);

      getErrorMessages(error).forEach((message) => {
        toast.error(`${message}`);
      });

      throw error;
    }
  },
};
